<template>
    <div class="divCouponDocWrap">
        <el-tabs :value="tabType" @tab-click="handleClick">
            <el-tab-pane label="默认文案(无需审核)" name="0">
              <div class="divCouponDocCouponWrap">
                <div class="divCouponCardWrap">
                  <div class="divCouponCardClick" v-for="(car, index) in defaultCouponStatusList"
                      :key="index" @click="clickCard(index)"
                  >
                    <CouponCard :validity="car.validity"
                      coupontype="XXX"
                      :couponname="car.couponName"
                      :status="car.status" :tip="car.couponRemark"
                      :width=256 :height=122 padding="15px 12px" nameSize="18px"
                    />
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="创建新的文案(需审核)" name="1">
              <div style="width:546px;">
                <el-form-item label="券名称" style="height: 58px;" label-width="none" prop="batchName">
                    <el-input placeholder='请输入如"人保专享"，最多13字' :value="couponNameInput" @input="inputCouponName"></el-input>
                </el-form-item>
                <el-form-item label="券说明" style="height: 58px;" label-width="none" prop="couponExplain">
                    <el-input placeholder='请输入如"人保为你保驾护航"，最多20字' :value="couponExplainInput" @input="inputCouponExplain"></el-input>
                </el-form-item>
              </div>
            </el-tab-pane>
            <el-tab-pane label="使用原有文案(无需审核)" name="2" :disabled="this.couponStatusDocList && this.couponStatusDocList.length === 0">
                <div class="divCouponDocCouponWrap">
                    <div class="divCouponCardWrap">
                        <div class="divCouponCardClick" v-for="(car, index) in couponStatusDocList"
                            :key="index" @click="clickCard(index)"
                        >
                            <CouponCard :validity="car.validity" :price="car.price"
                                coupontype="XXX"
                                :couponname="car.couponName"
                                :status="car.status" :tip="car.couponRemark"
                                :width=256 :height=122 padding="15px 12px" nameSize="18px"
                            />
                        </div>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import CouponCard from '../../../components/CouponCard'

export default {
  name: 'CouponDocument',
  data () {
    return {
      tabType: '0',
      couponNameInput: '',
      couponExplainInput: '',
      couponIdChoose: '',
      couponNameChoose: '',
      couponExplainChoose: '',
      couponIdDefaltChoose: '',
      couponNameDefaltChoose: '',
      couponExplainDefaltChoose: '',
      couponStatusDocList: null,
      defaultCouponStatusList: null,
      couponNameData: null,
      couponExplainData: null,
      couponTemplateIdData: null,
      defaultCouponInfo: null
    }
  },
  methods: {
    handleClick (tab, event) {
      if (tab.name === '0') {
        this.callbackCoupon('0')
      } else if (tab.name === '1') {
        this.callbackCoupon('1')
      } else if (tab.name === '2') {
        this.callbackCoupon('2')
      }
      this.tabType = tab.name
    },
    clickCard (index) {
      if (this.tabType === '2') {
        for (let i = 0; i < this.couponStatusDocList.length; i++) {
          this.$set(this.couponStatusDocList[i], 'status', '0')
        }
        this.couponStatusDocList[index].status = '1'
        this.$set(this.couponStatusDocList, index, this.couponStatusDocList[index])
        this.couponIdChoose = this.couponStatusDocList[index].id
        this.couponNameChoose = this.couponStatusDocList[index].couponName
        this.couponExplainChoose = this.couponStatusDocList[index].couponRemark
        this.callbackCoupon('2')
      } else if (this.tabType === '0') {
        for (let i = 0; i < this.defaultCouponStatusList.length; i++) {
          this.$set(this.defaultCouponStatusList[i], 'status', '0')
        }
        this.defaultCouponStatusList[index].status = '1'
        this.$set(this.defaultCouponStatusList, index, this.defaultCouponStatusList[index])
        this.couponIdDefaltChoose = this.defaultCouponStatusList[index].id
        this.couponNameDefaltChoose = this.defaultCouponStatusList[index].couponName
        this.couponExplainDefaltChoose = this.defaultCouponStatusList[index].couponRemark
        this.callbackCoupon('0')
      }
    },
    inputCouponName (couponName) {
      this.couponNameInput = couponName
      this.callbackCoupon('1')
    },
    inputCouponExplain (couponExplain) {
      this.couponExplainInput = couponExplain
      this.callbackCoupon('1')
    },
    /**
     * 给 defaultCoupon 赋 status，并且返回是否选中默认文案
     */
    getStatusDefaultCouponAndChooseFlag () {
      let chooseFlag = false
      if (this.defaultCouponStatusList.length > 0 && this.couponTemplateIdData) {
        for (let i = 0; i < this.defaultCouponStatusList.length; i++) {
          this.defaultCouponStatusList[i].status = '0'
          if (!chooseFlag) {
            if (this.defaultCouponStatusList[i].id == this.couponTemplateIdData) {
              this.defaultCouponStatusList[i].status = '1'
              this.$set(this.defaultCouponStatusList, i, this.defaultCouponStatusList[i])
              chooseFlag = true
              this.couponIdDefaltChoose = this.couponTemplateIdData
              this.couponNameDefaltChoose = this.defaultCouponStatusList[i].couponName
              this.couponExplainDefaltChoose = this.defaultCouponStatusList[i].couponRemark
            }
          }
        }
      }
      return chooseFlag
    },
    /**
     * 给 couponList 赋 status，并且返回是否选中原有文案
     */
    getStatusCouponAndChooseFlag () {
      let chooseFlag = false
      if (this.couponStatusDocList.length > 0 && this.couponTemplateIdData) {
        for (let i = 0; i < this.couponStatusDocList.length; i++) {
          this.couponStatusDocList[i].status = '0'
          if (!chooseFlag) {
            if (this.couponStatusDocList[i].id == this.couponTemplateIdData) {
              this.couponStatusDocList[i].status = '1'
              this.$set(this.couponStatusDocList, i, this.couponStatusDocList[i])
              chooseFlag = true
              this.couponIdChoose = this.couponTemplateIdData
              this.couponNameChoose = this.couponStatusDocList[i].couponName
              this.couponExplainChoose = this.couponStatusDocList[i].couponRemark
            }
          }
        }
      }
      return chooseFlag
    },
    /**
     * '0' 为默认，'1' 为输入新文案，'2' 为原有文案
     */
    callbackCoupon (type) {
      if (type === '0') {
        this.callback({
          couponId: this.couponIdDefaltChoose,
          couponName: this.couponNameDefaltChoose,
          couponExplain: this.couponExplainDefaltChoose
        })
      } else if (type === '1') {
        this.callback({
          couponName: this.couponNameInput,
          couponExplain: this.couponExplainInput
        })
      } else if (type === '2') {
        this.callback({
          couponId: this.couponIdChoose,
          couponName: this.couponNameChoose,
          couponExplain: this.couponExplainChoose
        })
      }
    }
  },

  computed: {
    // tabWidth () {
    //   if (this.tabType === '1') {
    //     return '740px'
    //   } else {
    //     return '740px'
    //   }
    // }
  },
  watch: {
    couponName (val) {
      if (val.length === 0) {
        this.couponNameInput = ''
        this.couponExplainInput = ''
      }
    }
  },
  created: function () {
    this.couponStatusDocList = this.couponDocList || null
    this.couponNameData = this.couponName || null
    this.couponExplainData = this.couponExplain || null
    this.couponTemplateIdData = this.couponTemplateId || null
    this.defaultCouponStatusList = this.defaultCoupon || null
    // 首先给默认文案列表加 status
    // 再默认选择第一条
    if (this.defaultCouponStatusList.length) {
      for (let i = 0; i < this.defaultCouponStatusList.length; i++) {
        this.defaultCouponStatusList[i].status = '0'
      }
      this.defaultCouponStatusList[0].status = '1'
      this.couponIdDefaltChoose = this.defaultCouponStatusList[0].id
      this.couponNameDefaltChoose = this.defaultCouponStatusList[0].couponName
      this.couponExplainDefaltChoose = this.defaultCouponStatusList[0].couponRemark
    }
    // 然后给原有文案列表加 status
    // 再默认选择第一条
    if (this.couponStatusDocList && this.couponStatusDocList.length) {
      for (let i = 0; i < this.couponStatusDocList.length; i++) {
        this.couponStatusDocList[i].status = '0'
      }
      this.couponStatusDocList[0].status = '1'
      this.couponIdChoose = this.couponStatusDocList[0].id
      this.couponNameChoose = this.couponStatusDocList[0].couponName
      this.couponExplainChoose = this.couponStatusDocList[0].couponRemark
    }
    let tabType = '0'
    let chooseFlag = this.getStatusCouponAndChooseFlag()
    let defaultCouponChooseFlag = this.getStatusDefaultCouponAndChooseFlag()
    if (chooseFlag) {
      tabType = '2'
    } else if (defaultCouponChooseFlag) {
      tabType = '0'
    } else if (this.couponTemplateIdData == '0') {
      tabType = '1'
      this.couponNameInput = this.couponNameData
      this.couponExplainInput = this.couponExplainData
    } else {
      tabType = '0'
    }
    if (!chooseFlag && !defaultCouponChooseFlag) {
      if (this.couponStatusDocList.length) {
        this.couponStatusDocList[0].status = '1'
      }
      if (this.defaultCouponStatusList.length) {
        this.defaultCouponStatusList[0].status = '1'
      }
    } else if (chooseFlag) {
      if (this.defaultCouponStatusList.length) {
        this.defaultCouponStatusList[0].status = '1'
      }
    } else if (defaultCouponChooseFlag) {
      if (this.couponStatusDocList.length) {
        this.couponStatusDocList[0].status = '1'
      }
    }
    this.tabType = tabType
    this.callbackCoupon(tabType)
  },
  components: {
    CouponCard
  },
  props: ['callback', 'defaultCoupon', 'couponDocList', 'couponName', 'couponExplain', 'couponTemplateId']
}
</script>

<style lang="stylus">
    .divCouponDocWrap {
      width: 548px;
      .divCouponDocCouponWrap {
          background: #F3F4F5;
          border-radius: 4px;
          max-height: 330px;
          overflow-y: auto;
          box-sizing: border-box;
          width 542px;
          .divCouponCardWrap {
              margin: 0px;
              width: 532px;

              .divCouponCardClick {
                  display: inline-block;
                  margin: 10px 10px 10px 10px;
                  cursor: pointer;
                  line-height: initial;
                  vertical-align: top;
                  .card_container .name_con{
                    max-width 100%;
                  }
              }
          }
      }

      .el-form-item {
        .el-form-item__label {
          width: 12%;
          padding-right: 2%;
        }
        .el-form-item__content {
          width: 87%;

          .el-input__inner {
            border-radius: 0px;
          }
        }
      }
    }
</style>
